import axios from "axios";
import * as config from "../config";
// import * as LocalStorageDefined from "../jsx/local_storage";

export const ApiManager = axios.create({
    baseURL: config.apiUrl,
    // headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': 'Bearer ' + localStorage.getItem(LocalStorageDefined.TOKEN)
    // }
});

ApiManager.interceptors.response.use(
    (response) => {
        return response;
    }
    , (error) => {
        if (error.response.status === 401) {
            // localStorage.removeItem(LocalStorageDefined.TOKEN);
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);
